import localUser from "../local/LocalUser"
import desHelper from "../epct/DesHelper"
const httpClient = {
    // 根据环境返回不同的服务器URL
    getServerUrl: function() {
        // 判断是否为开发环境
        if (process.env.NODE_ENV === 'development') {
            return "http://192.168.31.246:5008"; // 开发环境URL
        } else {
            // 生产环境可以使用默认值或从环境变量读取
            return "https://www.comekey.com"; // 生产环境URL
        }
    },
    ///执行api方法
    invoke:async function(cmd,data,callBack){
        var url = this.getServerUrl() +"/Action/Invoke"
        var req = {
            method:cmd,
            data:data,
        }
        var content = JSON.stringify(req)
        content = desHelper.encode(content)
        var res = await this.httpPost(url,content)
        if(res.error){
            // 网络错误之类的
            if(callBack && typeof callBack === 'function'){
                callBack(res);
                return;
            }
            return res;
        }
        if(res.code != 200){
            var rs = {error:desHelper.decode(res.info)}
            //系统错误
            if(callBack && typeof callBack === 'function'){
                callBack(rs);
                return;
            }
            return rs;
        }
        var rsOut = desHelper.decode(res.info)
        var obj = JSON.parse(rsOut)
        //系统错误
        if(callBack && typeof callBack === 'function'){
            callBack(obj);
            return;
        }
        return obj;
    },
    ///提交post请求
    httpPost:async function(url,data,callBack){
        try{
            var userId = ""
            var user = localUser.getLocalUser()
            if(user){
                userId = user.userId
            }
            // 构建完整URL
            const fullUrl = url;
            // 准备fetch选项
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'userid':userId
                },
                body: data
            };
            
            // 发送请求
            const response = await fetch(fullUrl, options);
            
            // 检查响应状态
            if(!response.ok){
                throw new Error(`HTTP错误!状态码: ${response.status}`);
            }
            
            // 解析响应数据
            const result = await response.json();
            
            // 调用回调函数
            if(callBack && typeof callBack === 'function'){
                callBack(result);
                return;
            }
            
            return result;
        }catch(error){
            console.error('HTTP POST请求失败:', error);
            // 调用回调函数并传递错误信息
            if(callBack && typeof callBack === 'function'){
                callBack({error: error.message});
            }
            return {error: error.message};
        }
    },
    ///提交get请求
    httpGet:async function(url){
        try{
            // 构建完整URL
            const fullUrl = url;
            
            // 准备fetch选项
            const options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                }
            };
            
            // 发送请求
            const response = await fetch(fullUrl, options);
            
            // 检查响应状态
            if(!response.ok){
                throw new Error(`HTTP错误!状态码: ${response.status}`);
            }
            
            // 解析响应数据
            const result = await response.json();
            
            return result;
        }catch(error){
            console.error('HTTP GET请求失败:', error);
            return {error: error.message};
        }
    }
}

export default httpClient